import { transformJob } from './fetchAccessAndJobInformationByPositionId';
import gql from 'graphql-tag';
import graphqlClient from 'src/graphql/client';
import { jobInformation } from './fragments/jobInformation.graphql';

const fetchAccessAndJobInformationByJobId = async (
  jobId: number,
  advertiserId: string,
) => {
  const { data } = await graphqlClient.query({
    variables: { jobId, advertiserId },
    query: gql`
      query AccessAndJobInformationByJobId($jobId: ID!, $advertiserId: ID!) {
        advertiserJobAccessByJobId(jobId: $jobId, advertiserId: $advertiserId) {
          accessType
          correctAdvertiserId
        }
        jobByJobId(jobId: $jobId, advertiserId: $advertiserId) {
          jobInformation {
            ...jobInformation
          }
        }
        cmSearchRolloutSettings {
          rolloutPercentage
          jobIdThreshold
        }
      }

      ${jobInformation}
    `,
  });
  const { advertiserJobAccessByJobId, jobByJobId, cmSearchRolloutSettings } =
    data;
  return {
    advertiserAccess: advertiserJobAccessByJobId,
    job: transformJob(jobByJobId),
    rolloutSettings: cmSearchRolloutSettings,
  };
};

export default fetchAccessAndJobInformationByJobId;
